import { Listbox } from '@headlessui/react';
import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './selectOption.css';

/*
#tailwind
selectOption selectOption--disabled selectOption--selected
*/

const SelectOption = ({ value, children, disabled, className, ...other }) => (
  <Listbox.Option
    key={value}
    value={value}
    disabled={disabled}
    className={({ active, selected }) =>
      bem`selectOption--${{
        active,
        disabled,
        selected,
      }} ${className}`
    }
    {...other}
  >
    <div className="selectOption__label">{children}</div>
  </Listbox.Option>
);

SelectOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

SelectOption.defaultProps = {
  value: undefined,
  children: undefined,
  disabled: false,
  className: undefined,
};

export default SelectOption;
